import { render, staticRenderFns } from "./DocumentacionTableFilters.vue?vue&type=template&id=463ec901&scoped=true"
import script from "./DocumentacionTableFilters.vue?vue&type=script&lang=ts"
export * from "./DocumentacionTableFilters.vue?vue&type=script&lang=ts"
import style0 from "./DocumentacionTableFilters.vue?vue&type=style&index=0&id=463ec901&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463ec901",
  null
  
)

export default component.exports